module.exports = __webpack_public_path__ + "static/img/17.e990474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/17.png
// module id = Truh
// module chunks = 0